import React, { FC, useEffect } from "react"
import { DetailsCard } from "../admin/DetailsCard"
import Location1 from "@/public/icons/location1.svg"
import Location2 from "@/public/icons/location2.svg"
import Image from "next/image"
import CarIcon from "@/public/icons/car.svg"
import { MexicoRates, SalesUsMarketResponseData } from "@/lib/types"
import { convertEquipmentType } from "@/lib/services"

type Props = {
  success: boolean
  mexicoRates?: MexicoRates | null
  listingData: SalesUsMarketResponseData
  setPortOfEntry: (name: string) => void
}

export const Details: FC<Props> = (props) => {
  useEffect(() => {
    props.setPortOfEntry(props.listingData.location.portOfEntry?.name)
  }, [props.listingData.location.portOfEntry?.name])

  return (
    <div
      className={
        (props.success ? "" : "opacity-50") + " relative col-span-12 mt-5"
      }
    >
      <div
        className={
          (props.success ? "hidden" : "block") +
          " absolute w-full h-full z-10 bg-blak"
        }
      ></div>
      <h1 className="dark:text-primary-10 text-light-2 2xl:text-28 text-2xl">
        Details - DAT
      </h1>
      <div className="grid md:grid-cols-3 grid-cols-1 md:gap-0 gap-8 justify-between w-full mt-4">
        <DetailsCard
          icon={Location1}
          heading={`${props.listingData.location?.origin.city}, ${props.listingData.location?.origin.state} ${props.listingData.location?.origin.zipCode}`}
          sub_heading={
            props.listingData.location?.origin.country == "MX"
              ? ""
              : `${props.listingData.datDetails.origin.capacityType || "-"} ${
                  props.listingData.datDetails.origin.MCIScore || "-"
                }`
          }
          ratio={props.listingData.datDetails.origin.marketRatio}
        />
        <div className="col-span-1 w-full flex flex-col items-center">
          <Image src={CarIcon.src} width={100} height={100} alt="icon" />
          <div className="w-full h-1 border-b-2 dark:border-secondary-11 border-gray-400"></div>
          {props.listingData.location.mileage ? (
            <div className="pb-6">
              <p className="py-5 dark:text-primary-10 text-black text-sm text-center">
                {convertEquipmentType(props.listingData.equipmentType)}
              </p>
              <p className="dark:text-primary-10 text-primary-1 text-center pl-3 text-sm">
                {props.listingData.location.mileage.total.toLocaleString()}{" "}
                Miles{" "}
                <span className="text-primary-16 text-center text-sm">
                  ({" "}
                  {props.listingData.location.mileage.domestic.toLocaleString()}{" "}
                  Miles +{" "}
                  {props.listingData.location.mileage.mexico.toLocaleString()}{" "}
                  Miles )
                </span>
              </p>
              <p className="text-accent text-center text-sm">
                {props.listingData.location.portOfEntry?.name}
              </p>
            </div>
          ) : (
            <p className="dark:text-primary-10 text-gray-600 text-center pt-7 pb-6 pl-3 text-sm">
              {props.listingData.carrierCostData.mileage} Miles -{" "}
              {props.listingData.equipmentType}
            </p>
          )}
          <div className="w-full h-1 border-b-2 dark:border-secondary-11 border-gray-400"></div>
        </div>
        <DetailsCard
          icon={Location2}
          heading={`${props.listingData.location?.destination.city}, ${props.listingData.location?.destination.state} ${props.listingData.location?.destination.zipCode}`}
          sub_heading={
            props.listingData.location?.destination.country == "MX"
              ? ""
              : `${
                  props.listingData.datDetails.destination.capacityType || "-"
                } ${props.listingData.datDetails.destination.MCIScore || "-"}`
          }
          ratio={props.listingData.datDetails.destination.marketRatio}
        />
      </div>
    </div>
  )
}
